import {
  ICardTransaction,
  IPaymentCard,
  TCardTotalLimits,
  PaymentCardActionName,
  IDigitizedCard,
  TDigitizedCardActions,
  TDigitizedCardReasonCode,
  TDigitizedCardStatus,
  IEnrollment,
} from '@/features/cards/store/models/card.model';
import {
  TEditBeneficiary,
  IBeneficiary,
  TMetaBeneficiary,
} from '@/features/beneficiaries/store/models/beneficiary.model';

import { IProfile } from '@/store/models/profile.model';
import { IRestrictionsGroup, TRestrictionsGroupType } from '@/store/models/restriction.model';
import { IScaWallet } from '@/store/models/sca.model';
import { IState, ICursorElements, IPagination } from '@/store/types/search.types';
import { ITaxResidence } from '@/store/models/taxResidence.model';
import { TDashboardConfigSettingsBeneficiaries } from '@/store/models/dashboard-config.model';

import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';
import { ProfileKycActionTypes, TProfileKycAction } from '@/features/kyc/store/types/profile-kyc.types';
import { GetChildrenTypes, TGetChildrenAction } from '@/features/company-members/store/types/company-members.types';
import { IUser } from '@/features/user/store/user.model';
import { TUserAction, UserActionTypes } from '@/features/user/store/user.types';
import { TWalletAction, WalletActionTypes } from '@/features/wallets/store/types/wallet.types';

export enum BaseProfileActionTypes {
  ADD_PROFILE = 'PROFILE.ADD_PROFILE',
  ADD_PROFILE_SUCCESS = 'PROFILE.ADD_PROFILE_SUCCESS',
  ADD_PROFILE_FAIL = 'PROFILE.ADD_PROFILE_FAIL',

  CREATE_CHILD_USER = 'PROFILE.CREATE_CHILD_USER',
  CREATE_CHILD_USER_SUCCESS = 'PROFILE.CREATE_CHILD_USER_SUCCESS',
  CREATE_CHILD_USER_FAIL = 'PROFILE.CREATE_CHILD_USER_FAIL',

  REMOVE_PROFILE = 'PROFILE.REMOVE_PROFILE',

  REMOVE_ALL_PROFILE = 'PROFILE.REMOVE_ALL_PROFILE',
  GET_MANDATARIES = 'PROFILE.GET_MANDATARIES',
  GET_MANDATARIES_SUCCESS = 'PROFILE.GET_MANDATARIES_SUCCESS',
  GET_MANDATARIES_FAIL = 'PROFILE.GET_MANDATARIES_FAIL',

  GET_BENEFICIARIES = 'PROFILE.GET_BENEFICIARIES',
  GET_BENEFICIARIES_SUCCESS = 'PROFILE.GET_BENEFICIARIES_SUCCESS',
  GET_BENEFICIARIES_FAIL = 'PROFILE.GET_BENEFICIARIES_FAIL',

  CREATE_BENEFICIARY = 'PROFILE.CREATE_BENEFICIARY',
  CREATE_BENEFICIARY_SUCCESS = 'PROFILE.CREATE_BENEFICIARY_SUCCESS',
  CREATE_BENEFICIARY_FAIL = 'PROFILE.CREATE_BENEFICIARY_FAIL',

  EDIT_BENEFICIARY = 'PROFILE.EDIT_BENEFICIARY',
  EDIT_BENEFICIARY_SUCCESS = 'PROFILE.EDIT_BENEFICIARY_SUCCESS',
  EDIT_BENEFICIARY_FAIL = 'PROFILE.EDIT_BENEFICIARY_FAIL',

  UPDATE_BENEFICIARY_STATUS = 'PROFILE.UPDATE_BENEFICIARY_STATUS',
  UPDATE_BENEFICIARY_STATUS_SUCCESS = 'PROFILE.UPDATE_BENEFICIARY_STATUS_SUCCESS',
  UPDATE_BENEFICIARY_STATUS_FAIL = 'PROFILE.UPDATE_BENEFICIARY_STATUS_FAIL',

  GET_CARDS = 'PROFILE.GET_CARDS',
  GET_CARDS_SUCCESS = 'PROFILE.GET_CARDS_SUCCESS',
  GET_CARDS_FAIL = 'PROFILE.GET_CARDS_FAIL',

  GET_CURRENT_CARD_TRANSACTIONS = 'PROFILE.GET_CURRENT_CARD_TRANSACTIONS',
  GET_CURRENT_CARD_TRANSACTIONS_SUCCESS = 'PROFILE.GET_CURRENT_CARD_TRANSACTIONS_SUCCESS',
  GET_CURRENT_CARD_TRANSACTIONS_FAIL = 'PROFILE.GET_CURRENT_CARD_TRANSACTIONS_FAIL',

  UPDATE_PAYMENT_CARD_LIMITS = 'PROFILE.UPDATE_PAYMENT_CARD_LIMITS',
  UPDATE_PAYMENT_CARD_LIMITS_SUCCESS = 'PROFILE.UPDATE_PAYMENT_CARD_LIMITS_SUCCESS',
  UPDATE_PAYMENT_CARD_LIMITS_FAIL = 'PROFILE.UPDATE_PAYMENT_CARD_LIMITS_FAIL',

  SET_CURRENT_CARD = 'PROFILE.SET_CURRENT_CARD',
  UNSET_CARDS = 'PROFILE.UNSET_CARDS',

  CREATE_CARD = 'PROFILE.CREATE_CARD',
  CREATE_CARD_SUCCESS = 'PROFILE.CREATE_CARD_SUCCESS',
  CREATE_CARD_FAIL = 'PROFILE.CREATE_CARD_FAIL',

  UPDATE_CARD = 'PROFILE.UPDATE_CARD',
  UPDATE_CARD_SUCCESS = 'PROFILE.UPDATE_CARD_SUCCESS',
  UPDATE_CARD_FAIL = 'PROFILE.UPDATE_CARD_FAIL',

  BLOCK_CARD = 'PROFILE.BLOCK_CARD',
  BLOCK_CARD_SUCCESS = 'PROFILE.BLOCK_CARD_SUCCESS',
  BLOCK_CARD_FAIL = 'PROFILE.BLOCK_CARD_FAIL',

  UPDATE_CARD_LIMITS = 'PROFILE.UPDATE_CARD_LIMITS',
  UPDATE_CARD_LIMITS_SUCCESS = 'PROFILE.UPDATE_CARD_LIMITS_SUCCESS',
  UPDATE_CARD_LIMITS_FAIL = 'PROFILE.UPDATE_CARD_LIMITS_FAIL',

  UPDATE_CARD_OPTIONS = 'PROFILE.UPDATE_CARD_OPTIONS',
  UPDATE_CARD_OPTIONS_SUCCESS = 'PROFILE.UPDATE_CARD_OPTIONS_SUCCESS',
  UPDATE_CARD_OPTIONS_FAIL = 'PROFILE.UPDATE_CARD_OPTIONS_FAIL',

  UPDATE_CARD_ACTIONS = 'PROFILE.UPDATE_CARD_ACTIONS',
  UPDATE_CARD_ACTIONS_SETPIN = 'PROFILE.UPDATE_CARD_ACTIONS_SETPIN',
  UPDATE_CARD_ACTIONS_SUCCESS = 'PROFILE.UPDATE_CARD_ACTIONS_SUCCESS',
  UPDATE_CARD_ACTIONS_FAIL = 'PROFILE.UPDATE_CARD_ACTIONS_FAIL',

  UNBLOCK_CVC = 'PROFILE.UNBLOCK_CVC',

  GET_CARD_ENROLLMENT = 'PROFILE.GET_CARD_ENROLLMENT',
  GET_CARD_ENROLLMENT_SUCCESS = 'PROFILE.GET_CARD_ENROLLMENT_SUCCESS',
  GET_CARD_ENROLLMENT_FAIL = 'PROFILE.GET_CARD_ENROLLMENT_FAIL',

  ENROLL_CARD = 'PROFILE.UPDATE_CARD_ENROLLMENT',
  ENROLL_CARD_SUCCESS = 'PROFILE.UPDATE_CARD_ENROLLMENT_SUCCESS',
  ENROLL_CARD_FAIL = 'PROFILE.UPDATE_CARD_ENROLLMENT_FAIL',

  DELETE_OOB_CARD_ENROLLMENT = 'PROFILE.DELETE_OOB_CARD_ENROLLMENT',
  DELETE_OOB_CARD_ENROLLMENT_SUCCESS = 'PROFILE.DELETE_OOB_CARD_ENROLLMENT_SUCCESS',
  DELETE_OOB_CARD_ENROLLMENT_FAIL = 'PROFILE.DELETE_OOB_CARD_ENROLLMENT_FAIL',

  SIMULATE_TRANSACTION = 'PROFILE.SIMULATE_TRANSACTION',
  SIMULATE_TRANSACTION_FAIL = 'PROFILE.SIMULATE_TRANSACTION_FAIL',
  SIMULATE_TRANSACTION_SUCCESS = 'PROFILE.SIMULATE_TRANSACTION_SUCCESS',

  GET_CUSTOM_RESTRICTIONS_GROUP = 'PROFILE.GET_CUSTOM_RESTRICTION_GROUP',
  GET_CUSTOM_RESTRICTIONS_GROUP_SUCCESS = 'PROFILE.GET_CUSTOM_RESTRICTION_GROUP_SUCCESS',
  GET_CUSTOM_RESTRICTIONS_GROUP_FAIL = 'PROFILE.GET_CUSTOM_RESTRICTION_GROUP_FAIL',

  ADD_CUSTOM_RESTRICTIONS_GROUP = 'PROFILE.ADD_CUSTOM_RESTRICTIONS_GROUP',
  ADD_CUSTOM_RESTRICTIONS_GROUP_SUCCESS = 'PROFILE.ADD_CUSTOM_RESTRICTIONS_GROUP_SUCCESS',
  ADD_CUSTOM_RESTRICTIONS_GROUP_FAIL = 'PROFILE.ADD_CUSTOM_RESTRICTIONS_GROUP_FAIL',

  UPDATE_CUSTOM_RESTRICTIONS_GROUP = 'PROFILE.UPDATE_CUSTOM_RESTRICTIONS_GROUP',
  UPDATE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS = 'PROFILE.UPDATE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS',
  UPDATE_CUSTOM_RESTRICTIONS_GROUP_FAIL = 'PROFILE.UPDATE_CUSTOM_RESTRICTIONS_GROUP_FAIL',

  SET_CURRENT_RESTRICTIONS_GROUP = 'PROFILE.SET_CURRENT_RESTRICTIONS_GROUP',

  DELETE_CUSTOM_RESTRICTIONS_GROUP = 'PROFILE.DELETE_CUSTOM_RESTRICTIONS_GROUP',
  DELETE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS = 'PROFILE.DELETE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS',
  DELETE_CUSTOM_RESTRICTIONS_GROUP_FAIL = 'PROFILE.DELETE_CUSTOM_RESTRICTIONS_GROUP_FAIL',

  GET_DIGITIZED_CARDS = 'PROFILE.GET_DIGITIZED_CARDS',
  GET_DIGITIZED_CARDS_SUCCESS = 'PROFILE.GET_DIGITIZED_CARDS_SUCCESS',
  GET_DIGITIZED_CARDS_FAIL = 'PROFILE.GET_DIGITIZED_CARDS_FAIL',

  UPDATE_DIGITIZED_CARDS_ACTIONS = 'PROFILE.UPDATE_DIGITIZED_CARDS_ACTIONS',
  UPDATE_DIGITIZED_CARDS_ACTIONS_SUCCESS = 'PROFILE.UPDATE_DIGITIZED_CARDS_ACTIONS_SUCCESS',
  UPDATE_DIGITIZED_CARDS_ACTIONS_FAIL = 'PROFILE.UPDATE_DIGITIZED_CARDS_ACTIONS_FAIL',

  GET_SCA = 'PROFILE.GET_SCA',
  GET_SCA_SUCCESS = 'PROFILE.GET_SCA_SUCCESS',
  GET_SCA_FAIL = 'PROFILE.GET_SCA_FAIL',

  GET_DELETED_SCA = 'PROFILE.GET_DELETED_SCA',
  GET_DELETED_SCA_SUCCESS = 'PROFILE.GET_DELETED_SCA_SUCCESS',
  GET_DELETED_SCA_FAIL = 'PROFILE.GET_DELETED_SCA_FAIL',

  DELETE_SCA = 'PROFILE.DELETE_SCA',
  DELETE_SCA_SUCCESS = 'PROFILE.DELETE_SCA_SUCCESS',
  DELETE_SCA_FAIL = 'PROFILE.DELETE_SCA_FAIL',

  RESET_PIN_SCA = 'PROFILE.RESET_PIN_SCA',
  RESET_PIN_SCA_SUCCESS = 'PROFILE.RESET_PIN_SCA_SUCCESS',
  RESET_PIN_SCA_FAIL = 'PROFILE.RESET_PIN_SCA_FAIL',

  UNLOCK_SCA = 'PROFILE.UNLOCK_SCA',
  UNLOCK_SCA_SUCCESS = 'PROFILE.UNLOCK_SCA_SUCCESS',
  UNLOCK_SCA_FAIL = 'PROFILE.UNLOCK_SCA_FAIL',

  LOCK_SCA = 'PROFILE.LOCK_SCA',
  LOCK_SCA_SUCCESS = 'PROFILE.LOCK_SCA_SUCCESS',
  LOCK_SCA_FAIL = 'PROFILE.LOCK_SCA_FAIL',

  GET_TAX_RESIDENCE = 'PROFILE.GET_TAX_RESIDENCE',
  GET_TAX_RESIDENCE_SUCCESS = 'PROFILE.GET_TAX_RESIDENCE_SUCCESS',
  GET_TAX_RESIDENCE_FAIL = 'PROFILE.GET_TAX_RESIDENCE_FAIL',
}

export const ProfileActionTypes = {
  ...ProfileKycActionTypes,
  ...GetChildrenTypes,
  ...BaseProfileActionTypes,
  ...UserActionTypes,
  ...WalletActionTypes,
} as const;
export interface IAddProfileAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_PROFILE;
}

export interface IAddProfileSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_PROFILE_SUCCESS;
  profile: IProfile;
}

export interface IAddProfileFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_PROFILE_FAIL;
  error: TAppError;
}

export interface IRemoveProfileAction extends IBaseAction {
  type: typeof ProfileActionTypes.REMOVE_PROFILE;
  userId: number;
}

export interface IRemoveAllProfileAction extends IBaseAction {
  type: typeof ProfileActionTypes.REMOVE_ALL_PROFILE;
}

export interface ICreateChildUserAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CHILD_USER;
  userId: number;
  batchIndex?: string;
}

export interface ICreateChildUserSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CHILD_USER_SUCCESS;
  user: IUser;
  batchIndex?: string;
}

export interface ICreateChildUserFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CHILD_USER_FAIL;
  userId: number;
  error: TAppError;
  batchIndex?: string;
}

export interface IGetMandatariesAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_MANDATARIES;
  userId: number;
}

export interface IGetMandatariesSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_MANDATARIES_SUCCESS;
  userId: number;
  mandataries: IBeneficiary[];
  pagination?: IPagination;
}

export interface IGetMandatariesFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_MANDATARIES_FAIL;
  userId: number;
  error: TAppError;
}

export interface IGetBeneficiariesAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_BENEFICIARIES;
  userId: number;
}

export interface IGetBeneficiariesSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_BENEFICIARIES_SUCCESS;
  userId: number;
  beneficiaries: IBeneficiary[];
  meta?: TMetaBeneficiary;
  pagination?: IPagination;
}

export interface IGetBeneficiariesFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_BENEFICIARIES_FAIL;
  userId: number;
  error: TAppError;
}

export interface ICreateBeneficiaryAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_BENEFICIARY;
  userId: number;
}

export interface ICreateBeneficiarySuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_BENEFICIARY_SUCCESS;
  beneficiary: IBeneficiary;
  beneficiaryType: TDashboardConfigSettingsBeneficiaries;
}

export interface ICreateBeneficiaryFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_BENEFICIARY_FAIL;
  userId: number;
  error: TAppError;
}
export interface IEditBeneficiaryAction extends IBaseAction {
  type: typeof ProfileActionTypes.EDIT_BENEFICIARY;
  beneficiary: TEditBeneficiary;
}

export interface IEditBeneficiarySuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.EDIT_BENEFICIARY_SUCCESS;
  beneficiary: IBeneficiary;
}

export interface IEditBeneficiaryFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.EDIT_BENEFICIARY_FAIL;
  beneficiary: TEditBeneficiary;
  error: TAppError;
}
export interface IUpdateBeneficiaryStatusAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_BENEFICIARY_STATUS;
  beneficiary: TEditBeneficiary;
  beneficiaryType: TDashboardConfigSettingsBeneficiaries;
}

export interface IUpdateBeneficiaryStatusSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_BENEFICIARY_STATUS_SUCCESS;
  beneficiary: IBeneficiary;
  beneficiaryType: TDashboardConfigSettingsBeneficiaries;
}

export interface IUpdateBeneficiaryStatusFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_BENEFICIARY_STATUS_FAIL;
  beneficiary: TEditBeneficiary;
  beneficiaryType: TDashboardConfigSettingsBeneficiaries;
  error: TAppError;
}
export interface IGetCardsAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARDS;
  userId: number;
}

export interface IGetCardsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARDS_SUCCESS;
  userId: number;
  cards: IPaymentCard[];
}

export interface IGetCardsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARDS_FAIL;
  userId: number;
  error: TAppError;
}

export interface IGetCurrentCardTransactionsAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CURRENT_CARD_TRANSACTIONS;
  userId: number;
  cardId: number;
}
export interface IGetCurrentCardTransactionsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CURRENT_CARD_TRANSACTIONS_SUCCESS;
  userId: number;
  cardId: number;
  paginateCardTransactions: ICursorElements<ICardTransaction>;
}

export interface IGetCurrentCardTransactionsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CURRENT_CARD_TRANSACTIONS_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IUpdatePaymentCardLimitAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_PAYMENT_CARD_LIMITS;
  userId: number;
  cardId: number;
}
export interface IUpdatePaymentCardLimitSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_PAYMENT_CARD_LIMITS_SUCCESS;
  userId: number;
  cardId: number;
  cardLimits: TCardTotalLimits;
}

export interface IUpdatePaymentCardLimitFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_PAYMENT_CARD_LIMITS_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface ISetCurrentCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.SET_CURRENT_CARD;
  userId: number;
  currentCardId: number;
}
export interface IUnsetCurrentCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.UNSET_CARDS;
  userId: number;
}

export interface IBlockCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.BLOCK_CARD;
  userId: number;
  cardId: number;
  blockAction: PaymentCardActionName;
}

export interface IBlockCardFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.BLOCK_CARD_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
  blockAction: PaymentCardActionName;
}

export interface IBlockCardSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.BLOCK_CARD_SUCCESS;
  userId: number;
  card: IPaymentCard;
  blockAction: PaymentCardActionName;
}

export interface ICreateCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CARD;
  userId: number;
}

export interface ICreateCardSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CARD_SUCCESS;
  userId: number;
  card: IPaymentCard;
}

export interface ICreateCardFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.CREATE_CARD_FAIL;
  userId: number;
  error: TAppError;
}

export interface IUpdateCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD;
  userId: number;
  cardId: number;
}

export interface IUpdateCardSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_SUCCESS;
  card: IPaymentCard;
}

export interface IUpdateCardFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IUpdateCardLimitsAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_LIMITS;
  userId: number;
  cardId: number;
}

export interface IUpdateCardLimitsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_LIMITS_SUCCESS;
  card: IPaymentCard;
}

export interface IUpdateCardLimitsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_LIMITS_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IUpdateCardOptionsAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_OPTIONS;
  userId: number;
  cardId: number;
}

export interface IUpdateCardOptionsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_OPTIONS_SUCCESS;
  card: IPaymentCard;
}

export interface IUpdateCardOptionsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_OPTIONS_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IUpdateCardActionsAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_ACTIONS;
  userId: number;
  cardId: number;
  action: PaymentCardActionName;
}

export interface IUpdateCardActionsSetPinAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_ACTIONS_SETPIN;
  userId: number;
  cardId: number;
  action: PaymentCardActionName;
  hasPayload: boolean;
}

export interface IUpdateCardActionsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_ACTIONS_SUCCESS;
  card: IPaymentCard;
  action: PaymentCardActionName;
}

export interface IUpdateCardActionsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CARD_ACTIONS_FAIL;
  userId: number;
  cardId: number;
  modifiedAction: PaymentCardActionName;
  error: TAppError;
}

export interface IGetCardEnrollmentAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARD_ENROLLMENT;
  userId: number;
  cardId: number;
}

export interface IGetCardEnrollmentSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARD_ENROLLMENT_SUCCESS;
  userId: number;
  cardId: number;
  enrollments: IEnrollment[];
}

export interface IGetCardEnrollmentFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CARD_ENROLLMENT_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IEnrollCardAction extends IBaseAction {
  type: typeof ProfileActionTypes.ENROLL_CARD;
  userId: number;
  cardId: number;
}

export interface IEnrollCardSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.ENROLL_CARD_SUCCESS;
  userId: number;
  cardId: number;
  method: IEnrollment;
}

export interface IEnrollCardFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.ENROLL_CARD_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface IDeleteOOBCardEnrollmentAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_OOB_CARD_ENROLLMENT;
  userId: number;
  cardId: number;
  authMethodId: string;
}

export interface IDeleteOOBCardEnrollmentSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_OOB_CARD_ENROLLMENT_SUCCESS;
  userId: number;
  cardId: number;
  authMethodId: string;
}

export interface IDeleteOOBCardEnrollmentFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_OOB_CARD_ENROLLMENT_FAIL;
  userId: number;
  cardId: number;
  error: TAppError;
}

export interface ISimulateCardTransaction extends IBaseAction {
  type: typeof ProfileActionTypes.SIMULATE_TRANSACTION;
  userId: number;
  cardId: number;
}

export interface ISimulateCardTransactionFail extends IBaseAction {
  type: typeof ProfileActionTypes.SIMULATE_TRANSACTION_FAIL;
  userId: number;
  cardId: number;

  error: TAppError;
}

export interface ISimulateCardTransactionSuccess extends IBaseAction {
  type: typeof ProfileActionTypes.SIMULATE_TRANSACTION_SUCCESS;
  userId: number;
  cardId: number;
}

export interface IGetCustomRestrictionsGroupAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CUSTOM_RESTRICTIONS_GROUP;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IGetCustomRestrictionsGroupSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CUSTOM_RESTRICTIONS_GROUP_SUCCESS;
  userId: number;
  cardId: number;
  restrictionsGroup: IRestrictionsGroup;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IGetCustomRestrictionsGroupFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_CUSTOM_RESTRICTIONS_GROUP_FAIL;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
  error: TAppError;
}

export interface IAddCustomRestrictionsGroupAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_CUSTOM_RESTRICTIONS_GROUP;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IAddCustomRestrictionGroupsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_CUSTOM_RESTRICTIONS_GROUP_SUCCESS;
  userId: number;
  cardId: number;
  restrictionsGroup: IRestrictionsGroup;
}

export interface IAddCustomRestrictionsGroupFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.ADD_CUSTOM_RESTRICTIONS_GROUP_FAIL;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
  error: TAppError;
}

export interface IUpdateCardRestrictionsGroupAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CUSTOM_RESTRICTIONS_GROUP;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IUpdateCardRestrictionsGroupSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS;
  userId: number;
  cardId: number;
  restrictionsGroup: IRestrictionsGroup;
}

export interface IUpdateCardRestrictionsGroupFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_CUSTOM_RESTRICTIONS_GROUP_FAIL;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
  error: TAppError;
}

export interface IDeleteCustomRestrictionsGroupAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_CUSTOM_RESTRICTIONS_GROUP;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IDeleteCustomRestrictionsGroupSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_CUSTOM_RESTRICTIONS_GROUP_SUCCESS;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
  card: IPaymentCard;
}

export interface IDeleteCustomRestrictionsGroupFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_CUSTOM_RESTRICTIONS_GROUP_FAIL;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
  error: TAppError;
}

export interface ISetCurrentRestrictionsGroupAction extends IBaseAction {
  type: typeof ProfileActionTypes.SET_CURRENT_RESTRICTIONS_GROUP;
  userId: number;
  cardId: number;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface IGetDigitizedCardsAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DIGITIZED_CARDS;
  cardId: number;
  userId: number;
}

export interface IGetDigitizedCardsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DIGITIZED_CARDS_SUCCESS;
  cardId: number;
  userId: number;
  cards: IDigitizedCard[];
}

export interface IGetDigitizedCardsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DIGITIZED_CARDS_FAIL;
  cardId: number;
  userId: number;
  error: TAppError;
}

export interface IUpdateDigitizedCardActionsAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_DIGITIZED_CARDS_ACTIONS;
  cardId: number;
  userId: number;
  digitizedCardId: string;
  action: TDigitizedCardActions;
  reasonCode: TDigitizedCardReasonCode;
}

export interface IUpdateDigitizedCardActionsSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_DIGITIZED_CARDS_ACTIONS_SUCCESS;
  status: TDigitizedCardStatus;
  cardId: number;
  userId: number;
  digitizedCardId: string;
  createdDate?: string;
  modifiedDate?: string;
}

export interface IUpdateDigitizedCardActionsFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UPDATE_DIGITIZED_CARDS_ACTIONS_FAIL;
  cardId: number;
  userId: number;
  digitizedCardId: string;
  action: TDigitizedCardActions;
  error: TAppError;
}

export interface IGetSCAAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_SCA;
  userId: number;
}

export interface IGetSCASuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_SCA_SUCCESS;
  userId: number;
  scaWallets: IScaWallet[];
}

export interface IGetSCAFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_SCA_FAIL;
  userId: number;
  error: TAppError;
}

export interface IGetDeletedSCAAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DELETED_SCA;
  userId: number;
}

export interface IGetDeletedSCASuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DELETED_SCA_SUCCESS;
  userId: number;
  scaWallets: ICursorElements<IScaWallet>;
}

export interface IGetDeletedSCAFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_DELETED_SCA_FAIL;
  userId: number;
  error: TAppError;
}

export interface IDeleteSCAAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_SCA;
  userId: number;
  scaWalletId: string;
}

export interface IDeleteSCASuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_SCA_SUCCESS;
  userId: number;
  scaWalletId: string;
}

export interface IDeleteSCAFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.DELETE_SCA_FAIL;
  userId: number;
  scaWalletId: string;
  error: TAppError;
}

export interface IResetSCAPINAction extends IBaseAction {
  type: typeof ProfileActionTypes.RESET_PIN_SCA;
  userId: number;
  scaWalletId: string;
}

export interface IResetSCAPINSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.RESET_PIN_SCA_SUCCESS;
  userId: number;
  scaWallet: IScaWallet;
}

export interface IResetSCAPINFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.RESET_PIN_SCA_FAIL;
  userId: number;
  scaWalletId: string;
  error: TAppError;
}
export interface IUnlockSCAAction extends IBaseAction {
  type: typeof ProfileActionTypes.UNLOCK_SCA;
  userId: number;
  scaWalletId: string;
}
export interface IUnlockSCASuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.UNLOCK_SCA_SUCCESS;
  userId: number;
  scaWallet: IScaWallet;
}
export interface IUnlockSCAFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.UNLOCK_SCA_FAIL;
  userId: number;
  scaWalletId: string;
  error: TAppError;
}

export interface ISecureSCAWalletAction extends IBaseAction {
  type: typeof ProfileActionTypes.LOCK_SCA;
  userId: number;
  scaWalletId: string;
}

export interface ISecureSCAWalletSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.LOCK_SCA_SUCCESS;
  userId: number;
  scaWallet: IScaWallet;
}

export interface ISecureSCAWalletFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.LOCK_SCA_FAIL;
  userId: number;
  scaWalletId: string;
  error: TAppError;
}

export interface IGetTaxResidenceAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_TAX_RESIDENCE;
  userId: number;
}

export interface IGetTaxResidenceSuccessAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_TAX_RESIDENCE_SUCCESS;
  userId: number;
  taxResidences: ITaxResidence[];
}

export interface IGetTaxResidenceFailAction extends IBaseAction {
  type: typeof ProfileActionTypes.GET_TAX_RESIDENCE_FAIL;
  userId: number;
  error: TAppError;
}

export type TProfileAction =
  | IAddProfileAction
  | IAddProfileSuccessAction
  | IAddProfileFailAction
  | IRemoveProfileAction
  | IGetCardsAction
  | IGetCardsSuccessAction
  | IGetCardsFailAction
  | ICreateCardAction
  | ICreateCardSuccessAction
  | ICreateCardFailAction
  | IUpdateCardAction
  | IUpdateCardSuccessAction
  | IUpdateCardFailAction
  | IUpdateCardOptionsAction
  | IUpdateCardOptionsSuccessAction
  | IUpdateCardOptionsFailAction
  | IUpdateCardActionsFailAction
  | IUpdateCardActionsAction
  | IUpdateCardActionsSetPinAction
  | IUpdateCardActionsSuccessAction
  | ISimulateCardTransaction
  | ISimulateCardTransactionFail
  | ISimulateCardTransactionSuccess
  | IGetMandatariesAction
  | IGetMandatariesSuccessAction
  | IGetMandatariesFailAction
  | IGetBeneficiariesAction
  | IGetBeneficiariesSuccessAction
  | IGetBeneficiariesFailAction
  | ICreateBeneficiaryAction
  | ICreateBeneficiarySuccessAction
  | ICreateBeneficiaryFailAction
  | IEditBeneficiaryAction
  | IEditBeneficiarySuccessAction
  | IEditBeneficiaryFailAction
  | IGetCustomRestrictionsGroupAction
  | IGetCustomRestrictionsGroupSuccessAction
  | IGetCustomRestrictionsGroupFailAction
  | IAddCustomRestrictionsGroupAction
  | IAddCustomRestrictionGroupsSuccessAction
  | IAddCustomRestrictionsGroupFailAction
  | IUpdateCardRestrictionsGroupAction
  | IUpdateCardRestrictionsGroupSuccessAction
  | IUpdateCardRestrictionsGroupFailAction
  | IDeleteCustomRestrictionsGroupAction
  | IDeleteCustomRestrictionsGroupSuccessAction
  | IDeleteCustomRestrictionsGroupFailAction
  | IGetDigitizedCardsAction
  | IGetDigitizedCardsSuccessAction
  | IGetDigitizedCardsFailAction
  | ISetCurrentRestrictionsGroupAction
  | ICreateChildUserAction
  | ICreateChildUserSuccessAction
  | ICreateChildUserFailAction
  | ISetCurrentCardAction
  | IBlockCardAction
  | IBlockCardFailAction
  | IBlockCardSuccessAction
  | IUpdateCardLimitsAction
  | IUpdateCardLimitsSuccessAction
  | IUpdateCardLimitsFailAction
  | IGetCurrentCardTransactionsAction
  | IGetCurrentCardTransactionsSuccessAction
  | IGetCurrentCardTransactionsFailAction
  | IUnsetCurrentCardAction
  | IUpdatePaymentCardLimitAction
  | IUpdatePaymentCardLimitSuccessAction
  | IUpdatePaymentCardLimitFailAction
  | IUpdateBeneficiaryStatusAction
  | IUpdateBeneficiaryStatusSuccessAction
  | IUpdateBeneficiaryStatusFailAction
  | IGetSCAAction
  | IGetSCASuccessAction
  | IGetSCAFailAction
  | IDeleteSCAAction
  | IGetDeletedSCAAction
  | IGetDeletedSCASuccessAction
  | IGetDeletedSCAFailAction
  | IDeleteSCASuccessAction
  | IDeleteSCAFailAction
  | IResetSCAPINAction
  | IResetSCAPINSuccessAction
  | IResetSCAPINFailAction
  | IUnlockSCAAction
  | IUnlockSCASuccessAction
  | IUnlockSCAFailAction
  | ISecureSCAWalletAction
  | ISecureSCAWalletSuccessAction
  | ISecureSCAWalletFailAction
  | IGetTaxResidenceAction
  | IGetTaxResidenceSuccessAction
  | IGetTaxResidenceFailAction
  | IUpdateDigitizedCardActionsAction
  | IUpdateDigitizedCardActionsSuccessAction
  | IUpdateDigitizedCardActionsFailAction
  | IGetCardEnrollmentAction
  | IGetCardEnrollmentFailAction
  | IGetCardEnrollmentSuccessAction
  | IDeleteOOBCardEnrollmentAction
  | IDeleteOOBCardEnrollmentSuccessAction
  | IDeleteOOBCardEnrollmentFailAction
  | IEnrollCardAction
  | IEnrollCardFailAction
  | IEnrollCardSuccessAction
  | TProfileKycAction
  | TGetChildrenAction
  | TUserAction
  | TWalletAction
  | IRemoveAllProfileAction;

export interface IProfileState extends IBaseState {
  profiles: IState<IState<IProfile>[]>;
  create?: IState;
}
